import { Alert, Box, Button, Typography } from "@mui/material";
import { Component, ErrorInfo, ReactNode } from "react";
import { recordUnhandledDiagnostic } from "./terminalDiagnostics";
import i18n from "./i18n";

export class DiagnosticErrorBoundary extends Component<
  { children: ReactNode }, { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    recordUnhandledDiagnostic(error, info.componentStack ?? undefined);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <Box sx={{ minHeight: "100dvh", display: "grid", placeItems: "center", p: 3 }}>
      <Box sx={{ width: "min(100%, 560px)" }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {i18n.t("transverse.diagnostic.unexpected")}
        </Alert>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          {i18n.t("transverse.diagnostic.autoSent")}
        </Typography>
        <Button variant="contained" onClick={() => window.location.reload()}>
          {i18n.t("common.actions.retry")}
        </Button>
      </Box>
    </Box>;
  }
}
